import { useMemo } from 'react'
import { useViewsQuery } from '../queries'

const useFavouritesAndViews = () => {
  const { data: listofViews } = useViewsQuery()
  const {
    favourite = [],
    private: privateItems = [],
    public: publicItems = [],
    shared = [],
  } = listofViews || {}

  const favourites = useMemo(() => favourite, [favourite])

  const views = useMemo(() => {
    const favouriteUUIDs = new Set(favourites.map((item) => item.uuid))

    return [...privateItems, ...shared, ...publicItems].filter(
      (item) => !favouriteUUIDs.has(item.uuid),
    )
  }, [favourites, privateItems, publicItems, shared])

  return { favourites, views }
}

export default useFavouritesAndViews
